import React from 'react';

import { ExternalIdentityProvidersFormComponent } from './ExternalIdentityProvidersFormComponent.default';

const ExternalProvidersComponentRevamp: React.FC = () => (
    <ExternalIdentityProvidersFormComponent />
);

export default ExternalProvidersComponentRevamp;
